import { CommonValue } from "./CommonValue";
import { CounterOrderSection } from "./CounterOrderSection";
import { GenitalHerpes } from "./GenitalHerpes";
import { HepatitisB } from "./HepatitisB";

class PersonalAntecedents extends CounterOrderSection {
    public Specify: string;
    public CardiacDisease: CommonValue;
    public Hypertension: CommonValue;
    public DVTorPE: CommonValue;
    public RenalDisease: CommonValue;
    public Diabetes: CommonValue;
    public ThyroidDisease: CommonValue;
    public Epilepsy: CommonValue;
    public BloodDyscrasia: CommonValue;
    public BloodTransfusions: CommonValue;
    public RhABOIncompatibility: CommonValue;
    public NeuropsychiatricDisease: CommonValue;
    public PreviousSurgery: CommonValue;
    public AllergiesAsthma: CommonValue;
    public HepatitisB: HepatitisB;
    public GenitalHerpes: GenitalHerpes;
    public ChickenPox: CommonValue;
    public STBBIs: CommonValue;

    constructor(fields?: Partial<PersonalAntecedents>) {
        super();
        Object.assign(this, fields);
        this.CardiacDisease = new CommonValue(fields?.CardiacDisease);
        this.Hypertension = new CommonValue(fields?.Hypertension);
        this.DVTorPE = new CommonValue(fields?.DVTorPE);
        this.RenalDisease = new CommonValue(fields?.RenalDisease);
        this.Diabetes = new CommonValue(fields?.Diabetes);
        this.ThyroidDisease = new CommonValue(fields?.ThyroidDisease);
        this.Epilepsy = new CommonValue(fields?.Epilepsy);
        this.BloodDyscrasia = new CommonValue(fields?.BloodDyscrasia);
        this.BloodTransfusions = new CommonValue(fields?.BloodTransfusions);
        this.RhABOIncompatibility = new CommonValue(fields?.RhABOIncompatibility);
        this.NeuropsychiatricDisease = new CommonValue(fields?.NeuropsychiatricDisease);
        this.PreviousSurgery = new CommonValue(fields?.PreviousSurgery);
        this.AllergiesAsthma = new CommonValue(fields?.AllergiesAsthma);
        this.HepatitisB = new HepatitisB(fields?.HepatitisB);
        this.GenitalHerpes = new GenitalHerpes(fields?.GenitalHerpes);
        this.ChickenPox = new CommonValue(fields?.ChickenPox);
        this.STBBIs = new CommonValue(fields?.STBBIs);
    }
}

export { PersonalAntecedents };
